<mat-slider
  (mousemove)="onMouseMove($event)"
  [min]="min"
  [max]="max"
  [step]="step"
  discrete
  [displayWith]="displayWith || formatLabel"
  [disabled]="disabled"
  *ngIf="range"
>
  <input [value]="valueStart" (valueChange)="onStartSliderChange($event)" matSliderStartThumb />
  <input [value]="valueEnd" (valueChange)="onEndSliderChange($event)" matSliderEndThumb />
</mat-slider>

<mat-slider
  (mousemove)="onMouseMove($event)"
  [min]="min"
  [max]="max"
  [step]="step"
  discrete
  [displayWith]="displayWith || formatLabel"
  [disabled]="disabled"
  *ngIf="!range"
>
  <input [value]="value" (valueChange)="onSliderChange($event)" matSliderThumb />
</mat-slider>
